import clsx from "clsx";

import { Button as ButtonV2 } from "../Button";
import { useIsMobile } from "../hooks/useIsMobile";
import { Typo } from "../Typo";

export type TourStepContentProps = {
  title: string;
  description: string;
  stepNumber: number;
  totalSteps: number;
  primaryLabel: string;
  onPrimary: () => void;
  secondaryLabel: string;
  onSecondary: () => void;
  heroImageSrc?: string;
  heroImageClassName?: string;
};

export const TourStepContent = ({
  title,
  description,
  stepNumber,
  totalSteps,
  primaryLabel,
  onPrimary,
  secondaryLabel,
  onSecondary,
  heroImageSrc,
  heroImageClassName,
}: TourStepContentProps) => {
  const isMobile = useIsMobile();

  return (
    <div className="w-[328px] lg:w-[512px]">
      <div
        aria-hidden={!heroImageSrc || undefined}
        className="relative aspect-video w-full overflow-hidden rounded-t-2xl bg-surface-secondary lg:aspect-auto lg:h-[280px] lg:rounded-t-3xl"
      >
        {heroImageSrc && (
          <img
            src={heroImageSrc}
            alt=""
            className={clsx("h-full w-full object-cover", heroImageClassName)}
          />
        )}
      </div>
      <div className="flex flex-col gap-4 p-4 lg:p-6">
        <div className="flex flex-col gap-2 lg:gap-4">
          <div className="flex items-center justify-between gap-4">
            <Typo
              element="h5"
              smType="headingMD"
              lgType="headingXL"
              className="min-w-0"
            >
              {title}
            </Typo>
            <Typo element="p" type="bodyXS" className="shrink-0">
              {stepNumber}
              <Typo element="span" type="bodyXS" textColor="text-text-tertiary">
                {`/${totalSteps}`}
              </Typo>
            </Typo>
          </div>
          <Typo
            element="p"
            type={isMobile ? "bodySM" : "bodyMD"}
            textColor="text-text-secondary"
            className="!font-body"
          >
            {description}
          </Typo>
        </div>
        <div className="flex gap-4">
          <ButtonV2
            type="button"
            variant="text"
            size={isMobile ? "md" : "lg"}
            className="flex-1"
            data-testid="portal_rebate_tour_modal_secondary_button"
            onClick={onSecondary}
          >
            {secondaryLabel}
          </ButtonV2>
          <ButtonV2
            type="button"
            variant="brand"
            size={isMobile ? "md" : "lg"}
            className="flex-1"
            data-testid="portal_rebate_tour_modal_primary_button"
            onClick={onPrimary}
          >
            {primaryLabel}
          </ButtonV2>
        </div>
      </div>
    </div>
  );
};
